<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" type="radio" label="运营模式" name="operation_mode" :options="operationMode"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()" clear-button @clear="$refs.searchForm.set({stationed_id: '', company_name: ''})"></c-form-item>
					<c-form-item type="checkbox" label="定制" name="customs" :options="iscustomData" v-if="systemConfig.product_custom == 'ON'"></c-form-item>
					<c-form-item type="select" label="商品类目" name="product_type_id" options="PRODUCT_CLASSIFY"></c-form-item>
                    <c-form-item type="checkbox" label="销售模式" name="sales_model" :options="salesModelOptions"></c-form-item>
                    <c-form-item type="select" label="可售范围" name="visible_user_type" :options="visibleUserType"></c-form-item>
					<c-form-item type="input" label="SKU编码" name="product_sku_code"></c-form-item>
					<c-form-item type="input" label="货号" name="product_itemnumber"></c-form-item>
					<c-form-item type="input" label="商品名称" name="product_name"></c-form-item>
					<c-form-item type="input" label="同款商品" name="same_product_name"></c-form-item>
					<c-form-item type="hidden" name="delivery_address_id"></c-form-item>
					<c-form-item type="input" label="发货地" name="delivery_address_name" readonly @click="$refs.deliveryAddressSelectorSearch.open()"></c-form-item>
					<c-form-item type="datetime" label="上下架时间" start-name="sell_state_start_date" end-name="sell_state_end_date"></c-form-item>
					<c-form-item type="checkbox" label="状态" name="state" :options="productState"></c-form-item>
                    <c-form-item type="checkbox" label="" name="is_same_product" :options="[{name: '有同款',value: 1}]"></c-form-item>
                    <!-- <c-form-item type="checkbox" name="present_level" :options="[{name: '赠送会员',value: 1}]"></c-form-item> -->
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_product_edit" color="sys" @click="selectClassify()">发布商品</c-button>
                <c-button power="b_product_edit" color="black" @click="setProductType()">设置商品类目</c-button>
                <c-button power="b_product_sold" color="black" hollow @click="soldHandle('in')">批量上架</c-button>
				<c-button power="b_product_sold" color="black" hollow @click="soldHandle('out')">批量下架</c-button>
				<c-button power="b_product_tag_set" color="black" hollow @click="setTags(1)">批量设置标签</c-button>
				<c-button power="b_product_delivery_set" color="black" hollow @click="setDeliveryAddresss(null)">批量设置发货地</c-button>
                <c-button power="b_set_virtual_sale"  color="black" @click="batchUpdateVirtualSale()">设置虚拟销量</c-button>
                <c-button power="b_product_import" icon="upload" color="black" @click="viewImportHistory()">商品导入</c-button>
			</m-operate>
			
			<c-table ref="table" >
				<c-table-column
					type="selector"
				></c-table-column>
				
				<c-table-column
					label="状态"
					name="state"
					width="60"
				>
					<template v-slot="{data}">
						<span v-if="data.state == 0" style="color:red">{{productStateName[data.state]}}</span>
						<span v-if="data.state == 1" style="color:#999999">{{productStateName[data.state]}}</span>
						<span v-if="data.state == 2" style="color:green">{{productStateName[data.state]}}</span>
						<span v-if="data.state == 3" style="color:blue">{{productStateName[data.state]}}</span>
						<span v-if="data.state == 4" style="color:red">{{productStateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="销售模式"
					name="sales_model"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.sales_model == 1">供货</span>
						<span v-if="data.sales_model == 2" style="color:blue">直销</span>
					</template>
				</c-table-column>

				<c-table-column
					label="可售范围"
					name="visible_user_type"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.visible_user_type == 0">所有用户</span>
						<span v-if="data.visible_user_type == 1" style="color:blue">普通用户</span>
						<span v-if="data.visible_user_type == 2" style="color:green">经销商</span>
					</template>
				</c-table-column>

				<!-- <c-table-column
					label="销售模式"
					name="sales_model"
					width="70"
				>
					<template v-slot="{data}">
						<span v-if="data.sales_model == 1">供货</span>
						<span v-if="data.sales_model == 2" style="color:blue">直销</span>
					</template>
				</c-table-column> -->

				<!-- <c-table-column
					label="赠送会员"
					name="present_level_name"
					width="70"
				>
					<template v-slot="{data}">
						<span v-if="data.present_level_name">{{data.present_level_name}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column> -->

				<c-table-column
					label="运营模式"
					name="operation_mode"
					width="80"
					v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" 
				>
					<template v-slot="{data}">
						{{productModeName[data.operation_mode]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="商家角色"
					name="stationed_auth_name"
					width="110"
					v-if="systemConfig.pt_mode == 2 && systemConfig.stationed_authname_enabled == 'ON'" 
				>
				</c-table-column>
				
				<c-table-column
					label="商家名称"
					name="stationed_name"
					width="150"
					v-if="systemConfig.pt_mode == 2" 
				></c-table-column>
				
				<c-table-column
					label="商品信息"
					name="product_name"
					width="350"
				>
					<template v-slot="{data}">
						<product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
						<product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
					</template>
				</c-table-column>

				<c-table-column
					label="同款商品"
					name="same_product_name"
					width="350"
				>
					<template v-slot="{data}">
						<product-info v-if="data.same_product_itemnumber" :image="data.same_product_img_url" :name="'【'+visibleUserTypeName[data.same_visible_user_type]+'】'+ data.same_product_itemnumber + ' - '+data.same_product_name"></product-info>
						<product-info v-else-if="data.same_product_name" :image="data.same_product_img_url" :name="'【'+visibleUserTypeName[data.same_visible_user_type]+'】'+ data.same_product_name"></product-info>
                        <span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="SKU编码"
					name="product_sku_code_list"
					width="200"
				>
                    <template v-slot="{data}">
                        <div v-if="data.product_sku_code_list && data.product_sku_code_list.length > 0" v-for="(item, i) in data.product_sku_code_list" :key="i">
                            <span>{{item}}</span>
                        </div>
                    </template>
				</c-table-column>

				<c-table-column
					label="定制"
					width="60"
					name="is_custom"
					v-if="systemConfig.product_custom == 'ON'"
				>
					<template #default="{data}">
						<span v-if="data.is_custom == 1" style="color:blue">支持</span>
						<span v-else style="color:#999">不支持</span>
					</template>
				</c-table-column>
				
				<!-- <c-table-column
					label="商品卖点"
					name="product_subtitle"
					width="100"
				></c-table-column> -->
				
				<c-table-column
					label="所属类目"
					name="product_type_full_name"
					width="100"
				></c-table-column>
				
				<c-table-column
					label="零售价(元)"
					name="product_price"
					width="140"
				>
					<template v-slot="{data}">
						￥{{data.product_price}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="发货地"
					name="product_delivery_address_name"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>

				<c-table-column
					label="实际销量"
					name="sale_count"
					width="80"
				></c-table-column>

				<c-table-column
					label="虚拟销量"
					name="virtual_sale"
					width="80"
				></c-table-column>

				<c-table-column
					label="上下架时间"
					name="sell_state_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="190"
				>
		            <template v-slot="{data}">
		              <c-table-button power="b_product_edit" v-if="data.stationed_id == 0 && data.operation_mode == 1" @click="navigateTo(`/product_edit/${data.product_id}`)">编辑</c-table-button>
		              <c-table-button power="b_product_edit" v-if="data.operation_mode == 2" @click="navigateTo(`/product_edit/${data.product_id}`)">查看</c-table-button>
		              <c-table-button power="b_product_sold" v-if="data.state == 1" @click="soldHandle('in', data)">上架</c-table-button>
			          <c-table-button power="b_product_sold" v-else-if="data.state == 2" @click="soldHandle('out', data)">下架</c-table-button>
			          <c-table-button power="b_product_sku_sold" v-if="data.state != 0" @click="skuSoldHandle(data)">SKU上下架</c-table-button>
		              <c-table-button power="b_product_stock" v-if="data.operation_mode == 1" @click="setStock(data)">库存设置</c-table-button>
		              <c-table-button power="b_product_edit" v-if="data.operation_mode == 1" @click="setPrice(data)">价格设置</c-table-button>
					  <c-table-button power="b_product_edit" v-if="data.state != 3 && data.state != 4 && data.platform_profit_model == 2" @click="editPriceProduct(data)">调整加价</c-table-button>
		              <c-table-button power="b_product_edit" v-if="data.stationed_id == 0 && data.operation_mode == 1 && (data.state == 0 || data.state == 1)" @click="delHandle(data)">删除</c-table-button>
		              <c-table-button power="b_product_tag_set" @click="setTags(0,data)">标签设置</c-table-button>
		              <c-table-button power="b_product_delivery_set" v-if="data.operation_mode == 1 && data.stationed_id == 0" @click="setDeliveryAddresss(data)">发货地设置</c-table-button>
		              <c-table-button power="b_product_share_set" v-if="data.operation_mode == 1 && data.stationed_id == 0" @click="setProductShare(data)">分享设置</c-table-button>
		            </template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="classifySelector" title="选择商品类目" width="750" @resolve="createProduct" @close="getClassify(0)">
			<div class="classify-select flex-center">
				<dl v-for="(level, i) in productClassify" :key="i">
					<dt>
						<i class="tf tf-search"></i>
						<input v-model="classifySearch[i]" type="text" @keyup.enter="getClassify(i)">
					</dt>
					<dd>
						<ul>
							<li v-for="(item, j) in level" :key="j" class="flex-between-center" :class="{'z-crt': item == currentClassify[i]}" @click="classifyHandle(item, i)">
								<span>{{item.type_name}}</span>
								<i v-show="item.is_parent > 0" class="tf tf-angle-right"></i>
							</li>
						</ul>
					</dd>
				</dl>
			</div>
		</c-dialog>
		
		<c-dialog ref="stockEdit" title="库存设置" width="750" @resolve="setStockHandle">
			<c-table ref="stockTable" height="500" :paging="false">
				<c-table-column
					label="规格名称"
					name="product_sku_spec"
					width="200"
				></c-table-column>
				
				<c-table-column
					label="实际库存"
					name="product_sku_stock"
					width="70"
				>
				</c-table-column>

				<c-table-column
					label="占用量"
					name="product_order_occupy_count"
					width="60"
				></c-table-column>

				<c-table-column
					width="100"
				>
					<template slot="head">
						<div class="flex-center-cross">
							<span>增减库存</span>
							<a style="margin-left: 10px;" @click="$refs.batchStockDialog.open()"><i class="tf tf-edit"></i></a>
						</div>
					</template>
					<template v-slot="{data}">
						<c-input v-model="data.revise_stock" type="number" :limit="[-data.product_sku_stock, 9999]"></c-input>
					</template>
				</c-table-column>

				<c-table-column
					label="可用库存"
					width="70"
				>
					<template v-slot="{data}">
						<span style="color:green" v-if="(data.product_sku_stock + (parseInt(data.revise_stock||0))) > data.product_order_occupy_count">{{data.product_sku_stock+(parseInt(data.revise_stock||0))-data.product_order_occupy_count}}</span>
						<span style="color:red" v-else>{{data.product_sku_stock+(parseInt(data.revise_stock||0))-data.product_order_occupy_count}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="调整后实际库存"
					name="product_sku_stock"
					width="120"
				>
					<template v-slot="{data}">
						{{parseInt(data.product_sku_stock) + (parseInt(data.revise_stock) || 0)}}
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>

        <c-dialog ref="tagEdit" title="标签设置" width="750" height="400" @resolve="setTagHandle">
            <div class="tag-list">
              <c-checkbox-group v-model="currentProductTag">
                <c-checkbox v-for="(item, i) in productTagList" :key="i" :value="item.id" class="tag-item">
                  <img v-if="item.tag_img" class="tag-img" :src="item.tag_img" alt="">
                  <span v-else class="tag-text" :style="{'border-color': item.tag_color, 'color': item.tag_color}">{{item.tag_name}}</span>
                </c-checkbox>
              </c-checkbox-group>
            </div>
        </c-dialog>
		
		<c-dialog ref="priceEdit" title="产品价格设置" width="750" @resolve="setPriceHandle">
			<c-table ref="priceTable" height="500" :paging="false">
				<c-table-column
					label="规格名称"
					name="product_sku_spec"
					width="160"
				></c-table-column>
				
				<c-table-column
					label="零售价"
					name="product_price"
					width="90"
				>
					<template slot="head">
						<div class="flex-center-cross">
							<span>零售价</span>
							<a style="margin-left: 10px;" @click="batchPriceHy()"><i class="tf tf-edit"></i></a>
						</div>
					</template>
					<template v-slot="{data}">
						<c-input v-model="data.product_price" type="number" decimal="2" :limit="[0.01,99999]"></c-input>
					</template>
				</c-table-column>
		
				<c-table-column
					width="90"
					label="分销商"
				>
					<template slot="head">
						<div class="flex-center-cross">
							<span>分销商</span>
							<a style="margin-left: 10px;" @click="batchPriceHy(1)"><i class="tf tf-edit"></i></a>
						</div>
					</template>
					<template v-slot="{data}">
						<c-input v-model="data.product_price_1" type="number" decimal="2" :limit="[0.01, data.product_price]"></c-input>
					</template>
				</c-table-column>
				
				<c-table-column
					width="100"
					label="县代价"
				>
					<template slot="head">
						<div class="flex-center-cross">
							<span>县代价</span>
							<a style="margin-left: 10px;" @click="batchPriceHy(2)"><i class="tf tf-edit"></i></a>
						</div>
					</template>
					<template v-slot="{data}">
						<c-input v-model="data.product_price_2" type="number" decimal="2" :limit="[0.1, data.product_price]"></c-input>
					</template>
				</c-table-column>

				<c-table-column
					width="100"
					label="市代价"
				>
					<template slot="head">
						<div class="flex-center-cross">
							<span>市代价</span>
							<a style="margin-left: 10px;" @click="batchPriceHy(3)"><i class="tf tf-edit"></i></a>
						</div>
					</template>
					<template v-slot="{data}">
						<c-input v-model="data.product_price_3" type="number" decimal="2" :limit="[0.1, data.product_price]"></c-input>
					</template>
				</c-table-column>

				<c-table-column
					width="100"
					label="省代价"
				>
					<template slot="head">
						<div class="flex-center-cross">
							<span>省代价</span>
							<a style="margin-left: 10px;" @click="batchPriceHy(4)"><i class="tf tf-edit"></i></a>
						</div>
					</template>
					<template v-slot="{data}">
						<c-input v-model="data.product_price_4" type="number"  decimal="2" :limit="[0.1, data.product_price]"></c-input>
					</template>
				</c-table-column>
				
				<c-table-column
					width="100"
					label="总经销"
				>
					<template slot="head">
						<div class="flex-center-cross">
							<span>总经销</span>
							<a style="margin-left: 10px;" @click="batchPriceHy(5)"><i class="tf tf-edit"></i></a>
						</div>
					</template>
					<template v-slot="{data}">
						<c-input v-model="data.product_price_5" type="number" decimal="2" :limit="[0.1, data.product_price]"></c-input>
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>

        <c-dialog ref="importHistoryListEdit" @close="closeImportHistoryListEdit" title="商品导入任务历史(近7天)" width="1050" :button="false">
            <m-operate>
                <c-button power="b_product_import"  color="black" @click="importProduct()">导入</c-button>
                <c-button  color="black" hollow @click="flushImportTable()">刷新</c-button>
            </m-operate>

            <c-table ref="importHistoryListTable" height="500">

                <c-table-column
                        label="任务ID"
                        name="id"
                ></c-table-column>

                <c-table-column
                        label="状态"
                        name="state"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state==0"><span style="color:#888888">待导入</span></span>
                        <span v-if="data.state==1"><span >导入中</span></span>
                        <span v-if="data.state==2"><span style="color:darkgreen">导入完成</span></span>
                        <span v-if="data.state==3"><span style="color:red">导入异常</span></span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="错误原因"
                        name="err_msg"
                        width="250"
                >
                    <template v-slot="{data}">
                        <span v-if="data.err_msg"><span style="color:#888888">缺少指定列[{{data.err_msg}}]</span></span>
                    </template>
                </c-table-column>


                <c-table-column
                        label="任务总条数"
                        name="total_items"
                ></c-table-column>

                <c-table-column
                        label="导入成功条数"
                        name="success_items"
                ></c-table-column>

                <c-table-column
                        label="导入失败条数"
                        name="err_items"
                ></c-table-column>

                <c-table-column
                        label="任务时间"
                        name="create_date"
                        width="140"
                ></c-table-column>

                <c-table-column
                        label="文件下载"
                        name="err_file_name"
                        width="100"
                >
                    <template v-slot="{data}">
                        <a v-if="data.err_file_path" class="s-link" :href='data.err_file_path' target="_blank">下载错误文件</a>
                        <a v-if="data.err_msg" class="s-link" :href='data.file_path' target="_blank">下载原文件</a>
                    </template>
                </c-table-column>

            </c-table>
        </c-dialog>
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
		<delivery-address-selector ref="deliveryAddressSelector" multiple @resolve="submitDeliveryAddressConfig"></delivery-address-selector>
		<delivery-address-selector ref="deliveryAddressSelectorSearch" @resolve="selectDeliveryAddress"></delivery-address-selector>

        <c-dialog ref="batchStockDialog" title="批量增减库存" width="400" height="140" @resolve="batchSetStock">
            <c-form ref="batchStockForm">
				<c-form-item type="number" label="增减库存" name="value"></c-form-item>
			</c-form>
        </c-dialog>

		<!--商品SKU管理弹窗-->
		<c-dialog ref="skuDialog" title="商品SKU管理" width="900" :button="false">
			<m-operate>
				<c-button power="b_product_sku_sold" color="black" hollow @click="skuHandle('in')">批量上架</c-button>
				&nbsp;
				<c-button power="b_product_sku_sold" color="black" hollow @click="skuHandle('out')">批量下架</c-button>
			</m-operate>
			<c-table ref="sku_table" v-model="productSKUList" height="500" :paging="false">
				<c-table-column
					type="selector"
					width="20"
				></c-table-column>

				<c-table-column
					label="商品规格"
					name="product_sku_spec"
					width="200"
				>
				</c-table-column>

				<c-table-column
					label="SKU编码"
					name="product_sku_code"
					width="100"
				></c-table-column>

				<c-table-column
					label="SKU重量(kg)"
					name="product_weight"
					width="100"
				>
				</c-table-column>

				<c-table-column
					label="售价(元)"
					name="product_price"
					width="120"
				>
					<template v-slot="{data}">
						￥{{data.product_price}}
					</template>
				</c-table-column>

				<c-table-column
					label="状态"
					name="state"
					width="60"
				>
					<template v-slot="{data}">
						<span v-if="data.sku_state == 1" style="color:red">下架</span>
						<span v-if="data.sku_state == 2" style="color:green">上架</span>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="80"
				>
					<template v-slot="{data}">
						<c-table-button power="b_product_sku_sold" v-if="data.sku_state == 1" @click="skuHandle('in', data)">上架</c-table-button>
						<c-table-button power="b_product_sku_sold" v-else-if="data.sku_state == 2" @click="skuHandle('out', data)">下架</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</c-dialog>
		
		<!--单商品调整加价-->
		<c-dialog ref="productPriceSupplier" title="商品调整加价" width="1100" height="500" @resolve="editPriceHandle">
			<module title="规格信息">
				<c-table ref="priceTableSupplier" height="auto" :paging="false">
					<c-table-column
						label="规格名称"
						name="product_sku_spec"
						width="300"
					></c-table-column>
				
					<c-table-column
						label="供应价"
						name="product_price_cost"
						width="150"
					>
						<template v-slot="{data}">
							￥{{data.product_price_cost}}
						</template>
					</c-table-column>
				
					<c-table-column
						label="当前售价"
						name="product_price"
						width="150"
					>
						<template v-slot="{data}">
							￥{{data.product_price}}
						</template>
					</c-table-column>
				
					<c-table-column
						label="加价金额"
						width="150"
					>
						<template slot="head">
							<div class="flex-center-cross">
								<span>加价金额</span>
								<a style="margin-left: 10px;" @click="$refs.batchPriceDialog.open()"><i class="tf tf-edit"></i></a>
							</div>
						</template>
						<template v-slot="{data}">
							<c-input v-model="data.product_raise_price" type="number" :limit="[0, 9999]" decimal="2"></c-input>
						</template>
					</c-table-column>
				
					<c-table-column
						label="调整后售价"
						name="product_sku_stock"
						width="150"
					>
						<template v-slot="{data}">
							￥{{(parseFloat(data.product_price_cost) + (parseFloat(data.product_raise_price) || 0)).toFixed(2)}}
						</template>
					</c-table-column>
				</c-table>
			</module>
			<module title="定制信息" v-show="isCustom == 1">
				<c-table ref="customTable" height="auto" :paging="false">
					<c-table-column
						label="定制项"
						name="item_name"
						width="200"
					>
					  <template v-slot="{data}">
						{{data.item_name}}{{data.param_value ? '【' + data.param_value + '】' : ''}}
					  </template>
					</c-table-column>
				
					<c-table-column
						label="定制位置"
						name="position_name"
						width="100"
					>
					  <template v-slot="{data}">
						<div v-if="data.position_name" class="flex-center-cross">
						  <c-image :src="data.position_image_url" preview size="30" style="margin-right: 10px;"></c-image>
						  <span>{{data.position_name}}</span>
						</div>
					  </template>
					</c-table-column>
				
					<c-table-column
						label="工艺名称"
						name="tech_name"
						width="100"
					></c-table-column>
				
					<c-table-column
						label="起定量"
						name="min_custom_count"
						width="60"
					></c-table-column>
				
					<c-table-column
						label="商家定制价"
						name="product_price_cost"
						width="80"
					>
					  <template v-slot="{data}">
						￥{{data.product_price_cost}}
					  </template>
					</c-table-column>
				
					<c-table-column
						label="当前定制价"
						name="product_price"
						width="80"
					>
					  <template v-slot="{data}">
						￥{{data.product_price}}
					  </template>
					</c-table-column>
				
					<c-table-column
						label="平台加价金额"
						width="100"
					>
							<template slot="head">
								<div class="flex-center-cross">
									<span>加价金额</span>
									<a style="margin-left: 10px;" @click="$refs.batchCustomPriceDialog.open()"><i class="tf tf-edit"></i></a>
								</div>
							</template>
					  <template v-slot="{data}">
						<c-input v-model="data.custom_raise_price" type="number" :limit="[0, 9999]" decimal="2"></c-input>
					  </template>
					</c-table-column>
				
					<c-table-column
						label="调整后定制价"
						name="product_sku_stock"
						width="100"
					>
					  <template v-slot="{data}">
						￥{{(parseFloat(data.product_price_cost) + (parseFloat(data.custom_raise_price) || 0)).toFixed(2)}}
					  </template>
					</c-table-column>
				</c-table>
			</module>
		</c-dialog>
		
		<!--单商品多SKU-设个各个SKU等级售价-->
		<c-dialog ref="batchPriceHyDialog" title="批量设置售价" width="400" height="140" @resolve="batchSetHyPrice">
		    <c-form ref="batchPriceHyForm">
				<c-form-item type="number" label="售价" :limit="[0,999]" name="value" decimal="2"></c-form-item>
			</c-form>
		</c-dialog>
		
		<!--单商品多SKU-->
		<c-dialog ref="batchPriceDialog" title="批量加价" width="400" height="140" @resolve="batchSetPrice">
		    <c-form ref="batchPriceForm">
				<c-form-item type="number" label="加价金额" :limit="[0,999]" name="value" decimal="2"></c-form-item>
			</c-form>
		</c-dialog>
		
		<!--单商品多SKU-->
		<c-dialog ref="batchCustomPriceDialog" title="批量加价" width="400" height="140" @resolve="batchSetCustomPrice">
		    <c-form ref="batchCustomPriceForm">
				<c-form-item type="number" label="加价金额" :limit="[0,999]" name="value" decimal="2"></c-form-item>
			</c-form>
		</c-dialog>
		
		<!--多商品-->
		<c-dialog ref="batchUpdatePriceDialog" title="批量调价" width="500" @resolve="batchUpdatePriceHandle">
		    <c-form ref="batchUpdatePriceForm">
				<c-form-item type="number" label="商品加价比例" :limit="[0,999]" name="add_product_ratio" decimal="0" input-unit="%" word="针对平台盈利模式为加价销售的商品生效" required></c-form-item>
				<c-form-item type="number" label="定制加价金额(单项)" :limit="[0,999]" name="add_custom_money" decimal="2" input-unit="元" word="针对平台盈利模式为加价销售的商品生效" required></c-form-item>
			</c-form>
		</c-dialog>
        <!--分享设置-->
        <c-dialog ref="productShareSetDialog" title="设置商品分享信息" width="600" height="350" @resolve="updateProductShareHandle">
            <c-form ref="productShareForm">
                <c-form-item type="hidden" name="same_product_id"></c-form-item>
                <c-form-item type="image" label="商品分享海报" name="share_img_url" file-word="不设置则默认使用商品主图；海报图片大小不能超过3MB，建议尺寸800*800">
                </c-form-item>
                <c-form-item label="同款商品" word="注：选择B商品最为A的同款商品，则A、B互为同款，如果将C设置为B的同款，则A、B的同款关系自动解除">
                    <c-button style="margin: 5px 0;" @click="$refs.productSelector.open()">选择同款</c-button>
                    &nbsp;
                    <c-button color="red" v-if="sameProductInfo && sameProductInfo.same_product_id" style="margin: 5px 0;" @click="removeSameProduct()">删除同款</c-button>
                    <div v-if="sameProductInfo" class="flex">
                        <c-image :src="sameProductInfo.same_product_img_url" size="100"></c-image>
                        <p style="width: 350px; margin-top: 10px; margin-left: 18px; line-height: 20px; font-size: 13px; color: #444;">{{sameProductInfo.same_product_name}}</p>
                    </div>
                </c-form-item>
            </c-form>
        </c-dialog>
        <!--多商批量设置虚拟销量-->
        <c-dialog ref="batchUpdateVirtualSaleDialog" title="批量设置虚拟销量" width="500" @resolve="batchUpdateVirtualSaleHandle">
            <c-form ref="batchUpdateVirtualSaleForm">
                <c-form-item type="number" label="虚拟销量" :limit="[0,999999]" name="virtual_sale" decimal="0"
                             word="将商品的虚拟销量直接修改为输入的数字，如：输入1000则商品虚拟销量设置为1000" required></c-form-item>
            </c-form>
        </c-dialog>
        <product-selector ref="productSelector" @resolve="sameProductSelecthandle"></product-selector>
    </page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	import deliveryAddressSelector from '@/components/service/delivery_address_selector.vue'  // 发货地
	import deliveryAddressSelectorSearch from '@/components/service/delivery_address_selector.vue'  // 发货地搜索
	import {mapState} from 'vuex'
    import productSelector from "@/components/service/product_selector.vue";

    export default {
		name: 'm_product_list',
		
		components: {
            productSelector,
			productInfo,
			stationedSelector,
			deliveryAddressSelector,
			deliveryAddressSelectorSearch
		},
		
		data() {
			return {
				salesModelOptions: [{
					name: '供货',
					value: 1
				}, {
					name: '直销',
					value: 2
				}],
				visibleUserType: [{
					name: '所有用户',
					value: -1
				}, {
					name: '普通用户',
					value: 1
				}, {
					name: '经销商',
					value: 2
				}],
				productState: [{
					name: '草稿',
					value: 0
				}, {
					name: '上架',
					value: 2
				}, {
					name: '下架',
					value: 1
				}],
				productModeName: {
					1: '平台自营',
					2: '商家自营'
				},
				iscustomData: [{
					name: '支持',
					value: '1'
				}, {
					name: '不支持',
					value: '0'
				}],
				operationMode: [{
						name: '平台自营',
						value: 1
					},{
						name: '商家运营',
						value: 2
					}
				],
				productClassify: [
					[], [], []
				],
				currentClassify: [],
				classifySearch: [],
				currentClassifyId: '',
                flushImportHisTableTimer: null,
				productTagList: [],
				currentProductTag: [],
				productSKUList:[],
				product_id:0,
				isCustom:0,
                visibleUserTypeName:{
                    0:'所有用户',
                    1:'普通用户',
                    2:'经销商'
                },
                sameProductInfo:{}  //同款商品信息
			}
		},
		
		computed: {
			...mapState(['systemConfig']),
			...mapState({
				productStateName: state => state.dict.productState
			})
		},
		
		mounted() {
			this.$refs.search.search();
			
			this.$bus.$on('productList.update', page => {
				this.$refs.table.update(page);
			});
		},
		
		methods: {
			searchHandle(data) {
				if (data.present_level && data.present_level.length > 0){
					data.present_level = 1;
				}else {
					data.present_level = null;
				}
				data.stationed_type = 1;
				this.$refs.table.load({
					url: '/product/list',
					data
				});
			},
			
			selectClassify() {
				if (!this.productClassify[0].length) {
					this.getClassify(0, 0);
				}
				this.$refs.classifySelector.open();
			},
			
			classifyHandle(item, level) {
				this.currentClassifyId = item.id;
				this.$set(this.currentClassify, level, item);
				if (level < 2) {
					this.getClassify(level+1, !item.is_parent);
				}
			},
			
			getClassify(level, empty) {
				new Promise(resolve => {
					if (empty) {
						resolve([]);
					} else {
						this.request({
							url: '/product_type/common_list',
							data: {
								type_name: this.classifySearch[level],
								parent_id: level ? this.currentClassify[level-1].id : 0
							},
							success: data => {
								if (!data) {
									this.$message({
										text: '未找到类目'
									});
									return;
								}
								
								resolve(data);
							}
						});
					}
				}).then(data => {
					this.$set(this.productClassify, level, data);
					for (let i=level; i<3; i++) {
						i > level && this.$set(this.productClassify, i, []);
						this.$set(this.currentClassify, i, undefined);
					}
					this.currentClassifyId = level ? this.currentClassify[level-1].id : '';
				});
				this.$set(this.classifySearch, level, '');
			},
			
			createProduct(stop) {
				if (!this.currentClassifyId) {
					stop();
					this.$message({
						text: '请选择类目'
					});
					return;
				}
				
				// 批量设置类目
				if (this._setProductTypeIds) {
					this.request({
						url: '/product/batch_set_type',
						data: {
							product_type_id: this.currentClassifyId,
							product_ids: this._setProductTypeIds
						},
						loading: true,
						success: data => {
							this.$message({
								text: '设置成功'
							});
							this.$refs.table.update();
						}
					});
					delete this._setProductTypeIds;
					return;
				}
				
				var name = [];
				this.currentClassify.forEach(item => {
					item && name.push(item.type_name);
				});
				this.navigateTo({
					path: '/product_apply',
					query: {
						classify: this.currentClassifyId,
						classifyName: name.join(',')
					}
				});
			},
			//商品上下架
			soldHandle(type, item) {
				var list = item ? [{
					data: item
				}] : this.$refs.table.getRow('selected');
				if (!list.length) {
					this.$message({
						text: '请选择要操作的商品'
					});
					return;
				}
				
				this.$confirm({
					text: `确定要${type == 'in' ? '上架' : '下架'}${item ? '该' : '所选'}商品吗？`,
					resolve: () => {
						this.request({
							url: '/product/sold',
							data: {
								type: type == 'in' ? 1 : 2,
								product_ids: Array.from(list, item => item.data.product_id)
							},
							loading: true,
							success: () => {
								list.forEach(item => {
									item.data.state = type == 'in' ? 2 : 1
								});
							}
						});
					}
				});
			},
			//SKU列表
			skuSoldHandle(data) {
				this.product_id = data.product_id;
				this.productSKUList = [];
				this.request({
					url: '/product/sku/list',
					data: {
						pageIndex:1,
						pageSize:9999,
						product_id: data.product_id
					},
					loading: true,
					success: data => {
						//展示SKU列表数据
						this.productSKUList = data;
						this.$refs.skuDialog.open();
					}
				});
			},
			//商品SKU上下架
			skuHandle(type, item) {
				var list = item ? [{
					data: item
				}] : this.$refs.sku_table.getRow('selected');
				if (!list.length) {
					this.$message({
						text: '请选择要操作的商品SKU'
					});
					return;
				}
				this.$confirm({
					text: `确定要${type == 'in' ? '上架' : '下架'}${item ? '该' : '所选'}商品SKU吗？`,
					resolve: () => {
						this.request({
							url: '/product/sku/sold',
							data: {
								product_id: this.product_id,
								type: type == 'in' ? 1 : 2,
								product_skus: Array.from(list, item => item.data.product_sku)
							},
							loading: true,
							success: () => {
								//刷新列表
								list.forEach(item => {
									item.data.sku_state = type == 'in' ? 2 : 1
								});
							}
						});
					}
				});
			},
			delHandle(params) {
				this.$confirm({
					text: '确定要删除商品【'+params.product_name+'】吗？',
					resolve: () => {
						this.request({
							url: '/product/del',
							data: {
								product_id: params.product_id
							},
							loading: true,
							success: data => {
                                console.log(data);
                                if(data){
                                    this.$confirm({
                                        text: data,  // 提示内容,
                                        buttonName: '知道了',  // 确定按钮文字
                                        cancelButton: false  // 是否显示取消按钮
                                    });
                                }else {
                                    this.$refs.table.update();
                                    this.$message({
                                        text: '商品删除成功！',
                                        icon: 'success'
                                    });
                                }
							}
						});
					}
				});
			},
			//库存设置
			setStock(item) {
				this._setStockId = item.product_id;
				this.$refs.stockEdit.open();
				this.$refs.stockTable.load({
					url: '/product/get_sku',
					data: {
						product_id: item.product_id
					},
					dataFormatter: data => {
						data.forEach(item => {
							item.revise_stock = '';
						});
						return data;
					}
				});
			},
			//提交库存设置数据
			setStockHandle(stop) {
				stop();
				this.request({
					url: '/product/set_sku_stock',
					data: {
						product_id: this._setStockId,
						product_sku_stock_list: Array.from(this.$refs.stockTable.getRow(), item => {
							return {
								product_sku: item.data.product_sku,
								product_total_count: parseInt(item.data.revise_stock) || 0
							}
						})
					},
					loading: true,
					success: data => {
						this.$message({
							text: '库存设置成功'
						});
						this.$refs.stockEdit.close();
					}
				});
			},
			//批量设置会员价格（弹框）
			batchPriceHy(level){
				this._batchLevel = level;
				this.$refs.batchPriceHyDialog.open();
			},
			//批量设置会员价格（设置）
			batchSetHyPrice(){
				let n = parseFloat(this.$refs.batchPriceHyForm.serialize().value);
				if (n == n) {
					this.$refs.priceTable.getRow().forEach(item => {
						if(this._batchLevel){
							if(this._batchLevel == 1){
								item.data.product_price_1 = n;
							}else if(this._batchLevel == 2){
                                item.data.product_price_2 = n;
                            }else if(this._batchLevel == 3){
								item.data.product_price_3 = n;
							}else if(this._batchLevel == 4){
								item.data.product_price_4 = n;
							}else if(this._batchLevel == 5){
								item.data.product_price_5 = n;
							}
						}else{
							item.data.product_price = n;
						}
					})
				}
				this.$refs.batchPriceHyForm.clear();
			},
			
			//分销价格设置
			setPrice(item) {
				this._setPriceId = item.product_id;
				this.$refs.priceEdit.open();
				this.$refs.priceTable.load({
					url: '/product/get_sku_distribute_price',
					data: {
						product_id: item.product_id
					}
				});
			},
			//提交分销价格设置数据
			setPriceHandle(stop){
				stop();
				var list = this.$refs.priceTable.getRow();
				var falg = true;
				var msg = '';
				list.forEach(item => {
					if(!item.data.product_price
                            || !item.data.product_price_1
                            || !item.data.product_price_2
                            || !item.data.product_price_3
                            || !item.data.product_price_4
                            || !item.data.product_price_5){
						falg = false;
						msg = '请设置规格为【'+item.data.product_sku_spec+'】的各等级售价';
						return;
					}
				});
				
				if(!falg){
					this.$message({
						text: msg
					});
					return ;
				}
				
				this.request({
					url: '/product/set_sku_distribute_price',
					data: {
						product_id: this._setPriceId,
						product_sku_price_list: Array.from(this.$refs.priceTable.getRow(), item => {
							return {
								product_sku: item.data.product_sku,
								product_price: parseFloat(item.data.product_price) || 0,
								product_price_1: parseFloat(item.data.product_price_1) || 0,
								product_price_2: parseFloat(item.data.product_price_2) || 0,
								product_price_3: parseFloat(item.data.product_price_3) || 0,
								product_price_4: parseFloat(item.data.product_price_4) || 0,
                                product_price_5: parseFloat(item.data.product_price_5) || 0

                            }
						})
					},
					loading: true,
					success: data => {
						this.$message({
							text: '价格设置成功'
						});
						this.$refs.table.update();
						this.$refs.priceEdit.close();
					}
				});
			},
			//标签设置
            setTags(batch,item) {
		          this.tagProductIds = [];
		          this.currentProductTag = [];
		          if(batch == 1){
		              var list = this.$refs.table.getRow('selected');
		              if (!list.length) {
		                  this.$message({
		                      text: '请选择要操作的商品'
		                  });
		                  return;
		              }
		              this.tagProductIds = Array.from(list,item=>{
		                  return item.data.product_id;
		              })
		          }else{
		              this.tagProductIds.push(item.product_id);
		          }
		          this.request({
		              url: '/product/get_product_tags',
		              data: {
		                  is_batch: batch,
		                  product_id: batch == 0 ? item.product_id : null
		              },
		              loading: true,
		              success: data => {
		                  this.productTagList = data.all_tags;
						  if (data.product_tags) {
							  this.$nextTick(() => {
							    this.currentProductTag = Array.from(data.product_tags, item => {
							      return item.tag_id;
							    });
							  });
						  }
		                  this.$refs.tagEdit.open();
		              }
                });
            },
            //保存方法
            setTagHandle(stop) {
	            stop();
	            this.request({
		              url: '/product/set_product_tags',
		              data: {
		                  product_ids: this.tagProductIds,
		                  tag_ids: this.currentProductTag
		              },
		              loading: true,
		              success: data => {
		                  this.$message({
		                      text: '标签设置成功'
		                  });
		                  //刷新商品列表
		                  this.$refs.table.update();
		                  this.$refs.tagEdit.close();
		              }
		          });
		    },
			//发货地设置
			setDeliveryAddresss(data) {
				this.tagProductIds = [];
				//批量操作
				if(data == null){
					var list = this.$refs.table.getRow('selected');
					if (!list.length) {
						this.$message({
							text: '请选择要设置的商品'
						});
						return;
					}
					var flag = true;
					list.forEach(function(item, index, array) {
						if(item.data.operation_mode == 1 && item.data.stationed_id ==0){
							
						}else{
							flag = false;
						}
					});
					
					if(!flag){
						this.$message({
							text: '只能选择运营后台发布的商品进行设置'
						});
						return false;
					}
					
					this.tagProductIds = Array.from(list,item=>{
						return item.data.product_id;
					})
				}else{
					this.tagProductIds.push(data.product_id);
				}
				this._deliveryAddressConfig = this.tagProductIds;
				this.$refs.deliveryAddressSelector.open(data?data.product_id:0);
			},
			//批量设置所属类目
            setProductType() {
				var list = Array.from(this.$refs.table.getRow('selected'), item => {
					return item.data.product_id;
				});
				if (!list.length) {
					this.$message({
						text: '请选择要设置的商品'
					});
					return;
				}
                this.$confirm({
                    text: '修改商品类目，将会清空商品已经设置的属性信息，请谨慎操作！',  // 提示内容,
                    buttonName: '确定修改',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        if (!this.productClassify[0].length) {
                            this.getClassify(0, 0);
                        }
                        this._setProductTypeIds = list;
                        this.$refs.classifySelector.open();
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
			},
			//提交发货地设置数据
			submitDeliveryAddressConfig(data) {
				this.request({
					url: '/product/set_product_delivery_addresss',
					data: {
			            product_ids: this._deliveryAddressConfig,
						delivery_address_ids: Array.from(data, item => {
							return item.id
						})
					},
					loading: true,
					success: () => {
						this.$refs.table.update();
					}
				});
			},
			//刷新
            flushImportTable(){
                this.$refs.importHistoryListTable.load({
                    url: '/import_job/list',
                    dataFormatter: data => {
                        return data;
                    }
                });
            },
			//商品导入
            viewImportHistory(){
                this.$refs.importHistoryListEdit.open();
                this.loadFlushHisTableTimer();
                this.$refs.importHistoryListTable.load({
                    url: '/import_job/list',
                    dataFormatter: data => {
                        return data;
                    }
                });
            },

            loadFlushHisTableTimer(){
                this.flushImportHisTableTimer = setInterval(()=>{
                    this.$refs.importHistoryListTable.load({
                        url: '/import_job/list',
                        dataFormatter: data => {
                            return data;
                        }
                    });
                },10000)
            },

            closeImportHistoryListEdit(){
                clearInterval(this.flushImportHisTableTimer);
                this.flushImportHisTableTimer =null;
            },

            importProduct() {
                this.$confirm({
                    title: '导入提示',
                    buttonName: '开始导入',  // 确定按钮文字
                    text: '请使用标准模板进行导入商品 <a href="https://cdn.tkvip.com/app_static/base/%E5%95%86%E5%93%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx" target="_blank" style="color:dodgerblue;">模板下载</a>',
                    resolve: () => {
                        this.uploadFile({
                            message: false,
                            success: data => {
                                this.request({
                                    url: '/import_job/add',
                                    data: {
                                        filePath: data.filePath
                                    },
                                    loading: true,
                                    timeout: false,
                                    success: (data, message) => {
                                        this.$message({
                                            text: "导入任务提交成功,导入结果稍后查询",
                                            icon: 'success'
                                        });
                                        this.$refs.importHistoryListTable.update();
                                    }
                                });
                            }
                        });
                    }
                })
            },
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			},
			selectDeliveryAddress(data) {
				this.$refs.searchForm.set({
					delivery_address_id: data[0].id,
					delivery_address_name: data[0].delivery_province_name+" "+data[0].delivery_city_name
				});
			},
			
			batchSetStock() {
				let n = parseFloat(this.$refs.batchStockForm.serialize().value);
				if (n == n) {
					this.$refs.stockTable.getRow().forEach(item => {
						item.data.revise_stock = n;
					})
				}
				this.$refs.batchStockForm.clear();
			},
			
			//批量调价弹框
			batchUpdatePrice(){
				this._productIds = [];
				//批量操作
				var list = this.$refs.table.getRow('selected');
				if (!list.length) {
					this.$message({
						text: '请选择要调价的商品'
					});
					return;
				}
				var flag = true;
				list.forEach(function(item, index, array) {
					if(item.data.state == 3 || item.data.state == 4){
						flag = false;
					}
				});
				
				if(!flag){
					this.$message({
						text: '待审核或驳回的商品不支持批量调价！'
					});
					return false;
				}
				
				this._productIds = Array.from(list,item=>{
					return item.data.product_id;
				})
				
				this.$refs.batchUpdatePriceForm.clear();
				this.$refs.batchUpdatePriceDialog.open();
			},
			//单个商品调整加价
			editPriceProduct(item) {
				this._productId = item.product_id;
				this.isCustom = item.is_custom;
				this.$refs.productPriceSupplier.open();
				this.$refs.priceTableSupplier.load({
					url: '/product/get_sku',
					data: {
						product_id: item.product_id
					}
				});
		
				if(this.isCustom == 1) {
					this.$refs.customTable.load({
						url: '/product/custom/info',
						data: {
							product_id: item.product_id
						},
						dataFormatter: data => {
							var tableData = [];
							data.forEach(item => {
							if(item.list.length != 0) {
								tableData = tableData.concat(item.list);
							}
							});
							return tableData;
						}
					});
				}
			},
			//单个商品多SKU调整普通加价
			batchSetPrice() {
				let n = parseFloat(this.$refs.batchPriceForm.serialize().value);
				if (n == n) {
					this.$refs.priceTableSupplier.getRow().forEach(item => {
						item.data.product_raise_price = n;
					})
				}
				this.$refs.batchPriceForm.clear();
			},
			//单个商品多SKU调整定制加价
			batchSetCustomPrice() {
				let n = parseFloat(this.$refs.batchCustomPriceForm.serialize().value);
				if (n == n) {
					this.$refs.customTable.getRow().forEach(item => {
						item.data.custom_raise_price = n;
					})
				}
				this.$refs.batchCustomPriceForm.clear();
			},
			
			//单个商品调整加价提交
			editPriceHandle(stop) {
				stop();
				this.request({
					url: '/product/raise/price',
					data: {
						product_id: this._productId,
						audit_type: 1,
						product_sku_price_list: Array.from(this.$refs.priceTableSupplier.getRow(), item => {
							return {
							  product_sku: item.data.product_sku,
							  product_raise_price: parseFloat(item.data.product_raise_price) || 0
							}
						}),
						product_custom_list: this.isCustom == 1 ? Array.from(this.$refs.customTable.getRow(), item => {
							item.data.custom_raise_price = parseFloat(item.data.custom_raise_price) || 0
							return item.data;
						}) : []
					},
					loading: true,
					success: data => {
						this.$message({
							text: '调整成功'
						});
						this.$refs.table.update();
						this.$refs.productPriceSupplier.close();
					}
				});
			},
			//批量调价提交
			batchUpdatePriceHandle(stop){
				stop();
				this.$refs.batchUpdatePriceForm.submit({
					url: '/product/batchUpdatePrice',
					rule: {
						add_product_ratio: [{
							type: 'empty',
							word: '请填写商品加价比例'
						}],
						add_custom_money: [{
							type: 'empty',
							word: '请填写定制加价金额(单项)'
						}]
					},
					dataFormatter: data => {
						return Object.assign(data, {
							product_ids: this._productIds
						});
					},
					success: (data, res) => {
						if(this.auditState == 1){
							this.$message({
								icon: 'success',
								text: '调价成功'
							});
						}
						this.$refs.table.update();
						this.$refs.batchUpdatePriceDialog.close();
					}
				});
			},
            //商品分享设置
            setProductShare(data) {
                this._mainProductId = data.product_id;
                if (data.same_product_id){
                    this.sameProductInfo = {
                        same_product_id:data.same_product_id,
                        same_product_img_url:data.same_product_img_url,
                        same_product_name:data.same_product_name
                    };
                }else {
                    this.sameProductInfo = {};
                }
                this.$refs.productShareForm.clear();
                this.$refs.productShareForm.set(data);
                this.$refs.productShareSetDialog.open();
            },
            //同款商品选择回调方法
            sameProductSelecthandle(data){
                this.$refs.productShareForm.set({
                    same_product_id:data[0].product_id
                });
                this.sameProductInfo = {
                    same_product_id:data[0].product_id,
                    same_product_img_url:data[0].product_img_url,
                    same_product_name:data[0].product_name
                };
            },
            //删除同款数据
            removeSameProduct(){
                this.$refs.productShareForm.set({
                    same_product_id:0
                });
                this.sameProductInfo = {};
            },
            //提交商品分享数据
            updateProductShareHandle(stop){
                stop();
                this.$refs.productShareForm.submit({
                    url: '/product/share/edit',
                    rule: {
                        same_product_id: [{
                            type: 'function',
                            fun: (data) => {
                                if (this._mainProductId == data){
                                    return false;
                                }
                                return true;
                            },
                            word: '不能选择自身作为同款商品'
                        }]
                    },
                    dataFormatter: data => {
                        return Object.assign(data, {
                            product_id: this._mainProductId
                        });
                    },
                    success: (data, res) => {
                        this.$message({
                            icon: 'success',
                            text: '操作成功'
                        });
                        this.$refs.table.update();
                        this.$refs.productShareSetDialog.close();
                    }
                });
            },
            //批量设置商品虚拟销量
            batchUpdateVirtualSale(){
                this._productIds = [];
                //批量操作
                var list = this.$refs.table.getRow('selected');
                if (!list.length) {
                    this.$message({
                        text: '请选择设置虚拟销量的商品'
                    });
                    return;
                }

                this._productIds = Array.from(list,item=>{
                    return item.data.product_id;
                })

                this.$refs.batchUpdateVirtualSaleForm.clear();
                this.$refs.batchUpdateVirtualSaleDialog.open();
            },
            //批量设置虚拟销量提交
            batchUpdateVirtualSaleHandle(stop){
                stop();
                this.$refs.batchUpdateVirtualSaleForm.submit({
                    url: '/product/set_virtual_sale',
                    rule: {
                        virtual_sale: [{
                            type: 'empty',
                            word: '请填写需要增减的虚拟销量'
                        }]
                    },
                    dataFormatter: data => {
                        return Object.assign(data, {
                            product_ids: this._productIds.join(",")
                        });
                    },
                    success: (data, res) => {
                        this.$message({
                            icon: 'success',
                            text: '虚拟销量设置成功'
                        });
                        this.$refs.table.update();
                        this.$refs.batchUpdateVirtualSaleDialog.close();
                    }
                });
            }
        }
	}
</script>

<style lang="stylus" scoped>
	.classify-select {
		padding: 10px;
		
		dl {
			width: 240px;
			border: 1px solid #ddd;
			
			&:nth-child(n+2) {
				border-left: none;
			}
			
			dt {
				position: relative;
				padding: 10px;
			
				.tf {
					position: absolute;
					width: 30px;
					line-height: 36px;
					font-size: 14px;
					text-align: center;
					color: #bbb;
				}
				
				input {
					box-sizing: border-box;
					width: 100%;
					height: 36px;
					border: none;
					padding: 0 10px 0 30px;
					background: #F5F5F5;
				}
			}
			
			dd {
				height: 290px;
				overflow: auto;
				
				li {
					padding: 0 14px;
					line-height: 36px;
					font-size: 13px;
					cursor: pointer;
					
					&:hover,
					&.z-crt {
						background: #FFF17E;
					}
				}
			}
		}
	}
	
	.tag {
		&-list {
			padding: 20px 20px 20px 10px;
		}
		
		&-item {
			margin-left: 10px;
		}
		
		&-img {
			height: 20px;
		}
		
		&-text {
			border: 1px solid #000;
			padding: 0 6px;
			line-height: 18px !important;
			font-size: 12px;
			font-weight: normal !important;
			color: #000;
		}
	}
</style>